export default __webpack_public_path__ + "assets/good-job-f3c4b427bb51072268a58791cde37854.svg";